module.exports = __webpack_public_path__ + "img/pic_tejin.7d115260.png";